/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_CancelledInputs */

const en_ocr_cancelled = /** @type {(inputs: Ocr_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR processing cancelled.`)
};

const fr_ocr_cancelled = /** @type {(inputs: Ocr_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement OCR annulé.`)
};

const de_ocr_cancelled = /** @type {(inputs: Ocr_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR-Verarbeitung abgebrochen.`)
};

const it_ocr_cancelled = /** @type {(inputs: Ocr_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione OCR annullata.`)
};

const ru_ocr_cancelled = /** @type {(inputs: Ocr_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка OCR отменена.`)
};

const es_ocr_cancelled = /** @type {(inputs: Ocr_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se canceló el procesamiento OCR.`)
};

const zh_cn2_ocr_cancelled = /** @type {(inputs: Ocr_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR处理已取消。`)
};

const ja_ocr_cancelled = /** @type {(inputs: Ocr_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR処理はキャンセルされました。`)
};

const hi_ocr_cancelled = /** @type {(inputs: Ocr_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओसीआर प्रोसेसिंग रद्द कर दी गई।`)
};

const pt_pt2_ocr_cancelled = /** @type {(inputs: Ocr_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processamento de OCR cancelado.`)
};

/**
* | output |
* | --- |
* | "OCR processing cancelled." |
*
* @param {Ocr_CancelledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_cancelled = /** @type {((inputs?: Ocr_CancelledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_CancelledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_cancelled(inputs)
	if (locale === "de") return de_ocr_cancelled(inputs)
	if (locale === "it") return it_ocr_cancelled(inputs)
	if (locale === "ru") return ru_ocr_cancelled(inputs)
	if (locale === "es") return es_ocr_cancelled(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_cancelled(inputs)
	if (locale === "ja") return ja_ocr_cancelled(inputs)
	if (locale === "hi") return hi_ocr_cancelled(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_cancelled(inputs)
	return en_ocr_cancelled(inputs)
});